import React, { useEffect } from 'react';
import { Word } from './Word';
import { Stack, Typography } from '@mui/material';
import { ProperNameShortAnswer } from '@par/shared/types/game';

type PropTypes = {
  answer?: string[][];
  correctAnswer: boolean;
  properNameShortAnswer?: ProperNameShortAnswer;
  question: string;
  timerLimitReached: boolean;
  unrevealedIndex?: number[];
};

export const StagedQuestionAnswer = ({
  answer,
  correctAnswer,
  properNameShortAnswer,
  question,
  timerLimitReached,
  unrevealedIndex,
}: PropTypes) => {
  const underline = (wordIndex: number) => {
    if (!properNameShortAnswer || !answer) return false;
    if (properNameShortAnswer === 'last word') {
      if (wordIndex === answer.length - 1) return true;
    }
    if (properNameShortAnswer === 'last two words') {
      if (wordIndex === answer.length - 1 || wordIndex === answer.length - 2)
        return true;
    }
    if (properNameShortAnswer === 'first two words') {
      if (wordIndex === 0 || wordIndex === 1) return true;
    }
    if (properNameShortAnswer === 'first word') {
      if (wordIndex === 0) return true;
    }
    return false;
  };

  return (
    <Stack spacing={4}>
      {/* Question on Desktop */}
      <Typography
        sx={{ display: { xs: 'none', sm: 'block' } }}
        textAlign="center"
        variant="h5"
        marginY="20px"
      >
        {question}
      </Typography>

      {/* Question on Mobile */}
      <Typography
        sx={{ display: { xs: 'block', sm: 'none' } }}
        textAlign="center"
        marginY="20px"
        paddingX={1}
      >
        {question}
      </Typography>

      <Stack
        direction="row"
        justifyContent="center"
        spacing={3}
        sx={{ flexWrap: 'wrap' }}
      >
        {answer
          ? answer.map((word, wordIndex) => (
              <Stack
                direction="row"
                spacing={1}
                justifyContent="center"
                flexWrap={{ xs: 'wrap', sm: 'initial' }}
                className={`answer-fade-in ${underline(wordIndex) ? '' : ''}`}
                key={`word-${wordIndex}`}
              >
                <Word
                  correctAnswer={correctAnswer}
                  underline={underline(wordIndex)}
                  timerLimitReached={timerLimitReached}
                  unrevealedIndex={unrevealedIndex}
                  word={word}
                  wordIndex={wordIndex}
                ></Word>
              </Stack>
            ))
          : null}
      </Stack>
    </Stack>
  );
};
